<script setup>
const props = defineProps({
  blok: {
    type: Array,
  },
})

const contentBulletStyle = computed(() => {
  switch (props.blok.style) {
    case 'list-disc':
      return '!list-disc'
    case 'list-decimal':
      return '[&>ul]:!list-decimal'
    default :
      return '!list-none !px-0'
  }
})
</script>

<template>
  <div class="relative">
    <div class="mb-custom-md flex flex-col gap-y-6">
      <slot />
    </div>
  </div>
</template>

<style scoped>
ul li::marker {
    @apply font-800 text-lg;
}

ul li h1, ul li h2, ul li h3, ul li h4, ul li h5 {
    @apply pr-2;
}

ul {
    @apply pl-8;
}
</style>
